import { API_RESOURCES } from 'src/utils/constants';

export const INVENTORY_ACTION_TYPES = {
  GROUP: 'instruction_group',
  PIECE: 'piece',
};

export const INVENTORY_ALLOWED_RESOURCES = {
  [INVENTORY_ACTION_TYPES.GROUP]: [API_RESOURCES.MATERIAL_CONTAINER],
  [INVENTORY_ACTION_TYPES.PIECE]: [API_RESOURCES.MATERIAL_CONTAINER],
};

export const INVENTORY_ACTIONS = {
  CONSUME: 'consume',
  RECLAIM: 'reclaim',
  REPLENISH: 'replenish',
};
